import {
  provideDarkTheme,
  SOFTLINE_CONFIG_DEFAULT_THEME,
  SOFTLINE_CONFIG_THEMES,
} from '@softline/application';
import { CustomerConfig } from 'apps/softapps/src/customer-config.type';

export const customerConfig: CustomerConfig = {
  version: '0.0.0',
  id: 'at.softline.lagerhaus.wechselgau.softline',
  name: 'Lagerhaus Wechselgau Softline',
  providers: [
    { provide: SOFTLINE_CONFIG_DEFAULT_THEME, useValue: 'lagerhaus' },
    provideDarkTheme(false),
    {
      provide: SOFTLINE_CONFIG_THEMES,
      useValue: {
        key: 'lagerhaus',
        name: 'Lagerhaus',
      },
      multi: true,
    },
  ],
  moduleConfig: { esl: ['link', 'storage', 'config'] },
};
